import React from 'react';
import { Typography, Radio, Space, Input } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import Card from '../card/Card';
import { useTheme } from '../../contexts/ThemeContext';

const { Text } = Typography;

const SynchronizationSchedule = ({ 
  name,
  syncType,
  erp,
  onChange,
  isEditing = false
}) => {
  const { theme, weakenColor } = useTheme();

  const handleNameChange = (e) => {
    const newName = e.target.value;
    if (onChange) {
      onChange({
        name: newName,
        type: syncType
      });
    }
  };

  const handleSyncTypeChange = (e) => {
    const selectedType = e.target.value;
    if (onChange) {
      if (erp === 3) {
        onChange({
          name: name,
          type: 1
        });
      } else {
      onChange({
        name: name,
        type: selectedType
      });
    }
  }
};

  const syncTypeOptions = [
    { 
      value:1, 
      label: 'Padrão',
      description: 'Sincronização padrão dos dados principais do ERP'
    },
    ...(erp !== 3 ? [{
      value: 2,
      label: 'Consolidado',
      description: 'Dados consolidados com análises e relatórios'
    }] : [])
  ];



  return (
    <Card 
      data-tour-id="sync-type-select"
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <SettingOutlined style={{ fontSize: 16, color: theme.primary }} />
          <span style={{ fontSize: 16, fontWeight: 600 }}>Configurações de Sincronização</span>
        </div>
      }
      style={{ marginBottom: 24 }}
    >
      <Text style={{ 
        display: 'block',
        marginBottom: 16,
        color: '#8c8c8c',
        fontSize: 14
      }}>
        Defina o nome e tipo da sincronização
      </Text>

      {/* Nome da Sincronização */}
      <div style={{ marginBottom: 24 }}>
        <Text style={{ 
          display: 'block',
          marginBottom: 8,
          fontSize: 14,
          fontWeight: 500,
          color: '#262626'
        }}>
          Nome da Sincronização <span style={{ color: '#ff4d4f' }}>*</span>
        </Text>
        <Input
          value={name || ''}
          onChange={handleNameChange}
          placeholder="Ex: Omie - Empresa Principal"
        />
      </div>

      {/* Tipo de Sincronização */}
      <div>
        <Text style={{ 
          display: 'block',
          marginBottom: 12,
          fontSize: 14,
          fontWeight: 500,
          color: '#262626'
        }}>
          Tipo de Sincronização <span style={{ color: '#ff4d4f' }}>*</span>
        </Text>
        
        <Radio.Group 
          value={syncType} 
          onChange={handleSyncTypeChange}
          style={{ width: '100%' }}
          disabled={isEditing}
        >
          <Space direction="horizontal" size="middle" style={{ width: '100%' }}>
            {syncTypeOptions.map((option) => (
              <div
                key={option.value}
                style={{
                  borderRadius: 8,
                  padding: 16,
                  backgroundColor: syncType === option.value ? weakenColor(theme.primary, 0.15) : '#fafafa',
                  cursor: isEditing ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  opacity: isEditing ? 0.6 : 1
                }}
                onClick={!isEditing ? () => handleSyncTypeChange({ target: { value: option.value } }) : undefined}
              >
                <Radio value={option.value} style={{ marginBottom: 8 }}>
                  <Text style={{ 
                    fontSize: 16, 
                    fontWeight: 600,
                    color: syncType === option.value ? theme.primary : '#262626'
                  }}>
                    {option.label}
                  </Text>
                </Radio>
                
                <div style={{ marginLeft: 24 }}>
                  <Text style={{ 
                    display: 'block',
                    fontSize: 14,
                    fontWeight: 500,
                    color: '#595959',
                    marginBottom: 4
                  }}>
                    {option.title}
                  </Text>
                  <Text style={{ 
                    display: 'block',
                    fontSize: 13,
                    color: '#8c8c8c',
                    lineHeight: '18px'
                  }}>
                    {option.description}
                  </Text>
                </div>
              </div>
            ))}
          </Space>
        </Radio.Group>
        
        {isEditing && (
          <Text style={{ 
            fontSize: 12, 
            color: '#8c8c8c', 
            marginTop: 8, 
            display: 'block' 
          }}>
            Tipo de sincronização não pode ser alterado após criação
          </Text>
        )}
      </div>
    </Card>
  );
};

export default SynchronizationSchedule; 